export const deleteFromFavorite = (id: number) => ({
  type: "@saga/DELETE_FROM_FAVORITE",
  payload: id,
});
